export const fetch = (input, init) => {
  // Support older browsers which default credentials is "omit".
  // Ref https://github.com/whatwg/fetch/pull/585
  const req = new Request(input, Object.assign({
    credentials: "same-origin"
  }, init));
  return self.fetch(req);
};
//# sourceMappingURL=fetch.js.map